<template lang="pug">
  .country
    .section
      .container
        component(:is="country" v-if="country" :country="country")

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'

import Austria from './../austria'
import Belgium from './../belgium'
import Germany from './../germany'
import Denmark from './../denmark'
import Latvia from './../latvia'
import Lithuania from './../lithuania'
import Netherlands from './../netherlands'
import Norway from './../norway'
import Poland from './../poland'
import Slovakia from './../slovakia'
import Finland from './../finland'
import Estonia from './../estonia'
import Ukraine from './../ukraine'
import Kazakhstan from './../kazakhstan'
import Romania from './../romania'
import Kyrgyzstan from './../kyrgyzstan'
import Hungary from './../hungary'
import BosniaAndHerzegovina from './../bosnia-and-herzegovina'
import Switzerland from './../switzerland'
import Serbia from './../serbia'
import Croatia from './../croatia'
import Montenegro from './../montenegro'
import Macedonia from './../macedonia'
import Russia from './../russia'
import Belarus from './../belarus'

export default {
  name: 'Country',
  components: {
    Austria,
    Belgium,
    Germany,
    Denmark,
    Latvia,
    Lithuania,
    Netherlands,
    Norway,
    Poland,
    Slovakia,
    Finland,
    Estonia,
    Ukraine,
    Kazakhstan,
    Romania,
    Kyrgyzstan,
    Hungary,
    BosniaAndHerzegovina,
    Switzerland,
    Serbia,
    Croatia,
    Montenegro,
    Macedonia,
    Russia,
    Belarus
  },
  data () {
    return {
      country: ''
    }
  },
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  created () {
    this.country = this.$route.params.country
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/country/index.vue